<template>
  <span>
    <header-cool></header-cool>    
    
    
    <body-content ></body-content>
    <footer-cool></footer-cool>
  </span>
</template>
<script>
import HeaderCool from '@/components/ThemeMegazine/pages/Header';
import BodyContent from '@/components/ThemeMegazine/pages/modulePage/Body';

import FooterCool from '@/components/ThemeMegazine/pages/Footer';

export default {
    name: 'module',
    data(){
      return{
        module_id:this.$route.params.module_id
      }
    },
    components:{        
        HeaderCool,
        FooterCool,
        BodyContent
    }
};
</script>
